<form [formGroup]="form">
  <div class="details">
    <div class="options">
      <div class="option">
        <input type="radio" name="paymentMethod" checked />
        <label i18n="Billet option as the payment method@@billetPaymentOption">Billet</label>
      </div>
      <div class="option" i18n-ngbTooltip="@@notYetAvailableUnderDevelopmentNotice" ngbTooltip="Not yet available / Under development" placement="top">
        <input type="radio" name="paymentMethod" disabled />
        <label i18n="Credit card option as the payment method@@creditCardPaymentOption">Credit Card</label>
      </div>
    </div>
    <div class="payment-processor" [ngClass]="showPaymentProcessorElement ? '' : 'hidden'">
      <div id="paymentProcessorElement"></div>
    </div>
    <div class="row">
      <div class="form-group col-12 col-md-12 col-xs-12 company">
        <label i18n="Label for the company input of the contact at the edit plan details page@@companyLabelEditPlanDetails">Company</label>
        <input type="text" class="form-control" formControlName="company" />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-4 col-xs-12">
        <label i18n="@@personTypeLabelEditPlanDetails">Person Type</label>
        <select class="form-control" formControlName="personType">
          <option value="0" i18n="Pessoa fisica@@privateIndividualPaymentFormSelectOption">Private individual</option>
          <option value="1" i18n="Pessoa jurídica@@companyPaymentFormSelectOption">Company</option>
        </select>
      </div>
      <div class="form-group col-md-4 col-xs-12">
        <label i18n="unique tax identification for the person paying, also known as CPF/CNPJ in Brazil@@taxIDLabelEditPlanDetails">Identification</label>
        <input type="text" class="form-control" formControlName="taxID">
      </div>
      <div class="form-group col-md-4 col-xs-12">
        <label i18n="@@stateInscriptionLabelEditPlanDetails">State Inscription</label>
        <input type="text" class="form-control" formControlName="stateInscription">
      </div>
    </div>
    <div class="row">
      <div class="form-group col-7 col-md-7 col-xs-12 billingEmail">
        <label i18n="@@billingEmailLabelEditPlanDetails">Billing Email</label>
        <input type="text" class="form-control" formControlName="billingEmail" />
      </div>
      <div class="form-group col-5 col-md-5 col-xs-12 daysBeforeDue">
        <label i18n="@@daysBeforeDueLabelEditPlanDetails">Days before due</label>
        <select class="form-control" formControlName="daysBeforeDue">
          <option value="5" i18n="@@daysBeforeDueOption5EditPlanDetails">5 days before</option>
          <option value="10" i18n="@@daysBeforeDueOption10EditPlanDetails">10 days before</option>
          <option value="15" i18n="@@daysBeforeDueOption15EditPlanDetails">15 days before</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-6 col-md-3 col-xs-12">
        <label i18n="@@zipCodeLabelEditPlanDetails">Zip Code</label>
        <input type="text" class="form-control" formControlName="zipCode" />
      </div>
      <div class="form-group col-sm-6 col-md-2 col-xs-12">
        <label i18n="@@StateLabelEditPlanDetails">State</label>
        <input type="text" class="form-control" formControlName="state" />
      </div>
      <div class="form-group col-sm-6 col-md-4 col-xs-12">
        <label i18n="@@CitLabelEditPlanDetails">City</label>
        <input type="text" class="form-control" formControlName="city" />
      </div>
      <div class="form-group col-sm-6 col-md-3 col-xs-12">
        <label i18n="@@neighborhoodLabelEditPlanDetails">Neighborhood</label>
        <input type="text" class="form-control" formControlName="neighborhood" />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-12 col-md-6 col-xs-12">
        <label i18n="@@address1LabelEditPlanDetails">Address</label>
        <input type="text" class="form-control" formControlName="address1" />
      </div>
      <div class="form-group col-sm-12 col-md-3 col-xs-12">
        <label i18n="@@address2LabelEditPlanDetails">Number</label>
        <input type="text" class="form-control" formControlName="address2" />
      </div>
      <div class="form-group col-sm-12 col-md-3 col-xs-12">
        <label i18n="@@address3LabelEditPlanDetails">Complement</label>
        <input type="text" class="form-control" formControlName="address3" />
      </div>
    </div>
  </div>
  <div class="review">
    <h3 i18n>Review</h3>
    <div class="cycle">
      <label class="title" i18n>Payment Cycle</label>
      <label i18n="@@monthlyPaymentCycleLabel">Monthly</label>
    </div>
    <hr/>
    <div class="plan">
      <div class="left">
        <label class="prefix" i18n>Plan</label>
        <label>{{ this.selectedPlan ? this.selectedPlan.name : "Current" }}</label>
      </div>
      <div class="right">{{ getSelectedPlanPrice(selectedPlan) }}</div>
      <div class="extra">
        <div class="deliveries"><span class="value">{{ getMonthlyDeliveryCount(selectedPlan) }}</span><span class="sufix" i18n="The sufix after the monthly number of deliveries in the payment method form@@sufixMonthlyDeliveriesPaymentMethodForm">monthly deliveries</span></div>
      </div>
    </div>
    <hr/>
    <div class="actions">
      <button type="submit" role="submit" [disabled]="sending || (success && !form.dirty)" class="btn btn-primary btn-full-width btn-with-left-icon" (click)="onFinishClick()">
        <i *ngIf="!sending" class="fa fa-rocket"></i>
        <i *ngIf="sending" class="fa fa-circle-o-notch fa-spin"></i>
        <span i18n="@@paymentMethodFinishButtonLabel">Finish</span>
      </button>
      <div class="alert alert-success" *ngIf="success">Successfully changed plan</div>
      <div class="alert alert-danger" *ngIf="formError">
        <div *ngFor="let line of formError.split('\n')">{{ line }}</div>
      </div>
    </div>
  </div>
</form>
